import dssLogo from "../../dss.png";

// A stroked moose-face mark. On the brand row (Home/Me/Signup header) it's
// drawn free-standing next to the wordmark; on Login/Signup it sits inside a
// white disc with a hairline ring so the thin strokes read with more visual
// weight at large sizes. See chats/chat3.md for how this settled.
export function LogoMark({ size = 56, disc = true }: { size?: number; disc?: boolean }) {
  if (!disc) {
    return (
      <img
        src={dssLogo}
        alt=""
        style={{ width: size, height: size, objectFit: "contain", display: "block", flexShrink: 0 }}
      />
    );
  }
  return (
    <div
      className="rounded-full bg-white ring-1 ring-ink flex items-center justify-center overflow-hidden flex-shrink-0"
      style={{ width: size, height: size }}
    >
      <img
        src={dssLogo}
        alt=""
        style={{ width: size * 0.72, height: size * 0.72, objectFit: "contain" }}
      />
    </div>
  );
}

export function BrandMark({ sub = "EST. MMXVIII", mark = true }: { sub?: string; mark?: boolean }) {
  return (
    <div className="flex gap-3.5 items-center">
      {mark ? (
        <LogoMark size={50} />
      ) : (
        <div className="w-[3px] self-stretch bg-ink rounded" />
      )}
      <div>
        <div className="font-display text-[22px] leading-[0.95] tracking-tight font-extrabold uppercase">
          Det Sydsvenske
          <br />
          Spejderkorps
        </div>
        <div className="font-mono text-[10px] tracking-[1.4px] text-ink3 mt-1.5">{sub}</div>
      </div>
    </div>
  );
}
